<template>
    <b-button
        variant="primary"
        @click.stop="confirmarEnviar()"
        class="float-right ml-2"
        :disabled="desabilitarEnviar"
    >
        <span> <i class="fa fa-paper-plane-o"></i> Enviar </span>
    </b-button>
</template>

<script>
import PesquisasServicos from './PesquisasServicos'

export default {
    props: {
        perguntas: {
            type: Array,
            default: () => []
        },

        pesquisa: {
            type: String
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarEnviar() {
            this.$swal({
                title: 'Enviar Respostas',
                html: `Confirma o envio das respostas da ${this.pesquisa}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.enviar()
                }
            })
        },

        enviar() {
            this.$store.dispatch('addRequest')
            let respostasDto = this.perguntas.map(item => {
                return { perguntaId: item.perguntaId, resposta: item.resposta }
            })
            PesquisasServicos.enviar(respostasDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Pesquisa enviada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$router.push({ name: 'Home' })
                    } else {
                        this.$toast.error(
                            'Erro ao enviar pesquisa!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        desabilitarEnviar() {
            return !this.perguntas.every(
                item => item.resposta != null && item.resposta.trim() != ''
            )
        }
    },

    watch: {},

    validations: {}
}
</script>
